import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import DashSummary from "../../components/agent-ui/DashSummary";
import PropertyListings from "../../components/agent-ui/PropertyListings";
import ActiveTenants from "../../components/agent-ui/ActiveTenants";
import { AxiosAuthGet } from "../../api/api";
import Loading from "../../components/ui/Loading";
import { useNavigate } from "react-router-dom";

const Overview = () => {
  const url = "agent/dashboard/";
  const [isLoading, setIsLoading] = useState(false);
  const [dashData, setDashData] = useState([]);
  const navigate = useNavigate();
  
  const addProp = () => {
    navigate("/agent/property/add");
  }

  const getOverview = () => {
    setIsLoading(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setDashData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.error(err.response);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getOverview();
    // eslint-disable-next-line
  }, []);
  // console.log(dashData);
  
    const eachSum = [
        {
            total: dashData?.totalProperty ,
            text: "Total Properties"
        },
        {
            total: dashData?.rentToCollect,
            text: "Properties Vacant"
        },
        {
            total: dashData?.propertiesVacant,
            text: "Properties Occupied"
        },
        {
            total: dashData?.propertiesOccupied,
            text: "Properties for Rent"
        },
    ]
  

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && (
        <div>
          <AgentHeader
            header={"Dashboard"}
            btnText={"Add Property"}
            placeholder={"Search for property"}
            isSearch
            btnClick={addProp}
          />
          <DashSummary eachSum={eachSum} />
          <div
            className="dash-body"
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              margin: "20px 0",
            }}
          >
            <PropertyListings />
            <ActiveTenants />
          </div>
        </div>
      )}
    </>
  );
};

export default Overview;
